import { transparentize } from "polished";
import styled, { keyframes } from "styled-components";

interface SpinnerLoadingAttrs {
  color?: string;
  background?: string;
  size?: number;
  thickness?: number;
}

const SpinnerLoadingAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;

const SpinnerLoading = styled.div<SpinnerLoadingAttrs>`
  display: block;
  font-size: ${({ size }) => size || 9}px;
  position: relative;
  text-indent: -9999em;
  border: ${({ thickness }) => thickness || 2}px solid
    ${({ background, theme }) => background || transparentize(0.6, theme.text)};
  border-left: ${({ thickness }) => thickness || 2}px solid
    ${({ color, theme }) => color || theme.text};
  border-radius: 50%;
  width: 2em;
  height: 2em;
  transform: translateZ(0);
  animation: ${SpinnerLoadingAnimation} 1.1s infinite linear;
`;

export default SpinnerLoading;
